import {
	Component, Input, Output, EventEmitter, OnChanges, SimpleChanges,
	ChangeDetectorRef, ChangeDetectionStrategy, SimpleChange, OnInit
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ComponentBase } from 'common';

@Component({
    selector: 'map-export',
	templateUrl: '../map-export/map-export.component.html',
	styleUrls: ['../map-export/map-export.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapExportComponent extends ComponentBase implements OnInit {

	@Input()
	public mode: string;

	@Input()
	public title: string;

	@Input()
	public display: boolean;

	@Output()
	public displayChange: EventEmitter<any>;

	@Output()
	public onCancel: EventEmitter<any>;

	@Output()
	public onExport: EventEmitter<any>;

	public settingsForm: UntypedFormGroup;
	public sheetsAcross: UntypedFormControl;
	public sheetsDown: UntypedFormControl;
	public includeDeviceLabels: UntypedFormControl;
	public includeDeviceProperties: UntypedFormControl;
	public includeLinkLabels: UntypedFormControl;
	public includeLinkProperties: UntypedFormControl;
	public vsdxFormat: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder,
		private changeDetector: ChangeDetectorRef) {

		super();

		this.mode = "";
		this.title = "";
		this.display = false;
		this.displayChange = new EventEmitter<any>();
		this.onCancel = new EventEmitter<any>();
		this.onExport = new EventEmitter<any>();
	}

	public show(): void {
		this.display = true;
		this.displayChange.emit();
		this.changeDetector.markForCheck();
	}
	public hide(): void {
		this.display = false;
		this.displayChange.emit();
		this.changeDetector.markForCheck();
	}

	public ngOnInit(): void {
		this.buildForm();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		change = changes["display"];
		if (change) {
			this.buildForm();
		}
	}

	private buildForm(): void {
		this.sheetsAcross = new UntypedFormControl(1, Validators.compose([this.minValue(1), this.maxValue(50)]));
		this.sheetsDown = new UntypedFormControl(1, Validators.compose([this.minValue(1), this.maxValue(50)]));
		this.includeDeviceLabels = new UntypedFormControl(true);
		this.includeDeviceProperties = new UntypedFormControl(true);
		this.includeLinkLabels = new UntypedFormControl(true);
		this.includeLinkProperties = new UntypedFormControl(true);
		this.vsdxFormat = new UntypedFormControl(true);

		this.settingsForm = this.fb.group({
			sheetsAcross: this.sheetsAcross,
			sheetsDown: this.sheetsDown,
			includeDeviceLabels: this.includeDeviceLabels,
			includeDeviceProperties: this.includeDeviceProperties,
			includeLinkLabels: this.includeLinkLabels,
			includeLinkProperties: this.includeLinkProperties,
			vsdxFormat: this.vsdxFormat,
		});
	}

	public get enableExport(): boolean {
		return this.settingsForm.valid;
	}

	public cancel(): void {
		this.hide();
		this.onCancel.emit();
	}

	public export(): void {
		this.hide();

		let event = {
			sheetsAcross: this.sheetsAcross.value,
			sheetsDown: this.sheetsDown.value,
			includeDeviceLabels: this.includeDeviceLabels.value,
			includeDeviceProperties: this.includeDeviceProperties.value,
			includeLinkLabels: this.includeLinkLabels.value,
			includeLinkProperties: this.includeLinkProperties.value,
			vsdxFormat: this.vsdxFormat.value,
		};
		this.onExport.emit(event);
	}

}
